import React, { useState } from "react";

import _ from "lodash";

import Tile from "shared/components/Tile";
import Tooltip from "shared/components/Tooltip";
import FormulaVersionHistory from "shared/components/vega/LumenStudio/FormulaVersionHistory";
import { Timestamp } from "shared/components/vega/Timestamp";

const Workflow = ({
  workflow,
  readOnly = false,
  children = null,
  showVersionHistory = false,
  expand = false,
}) => {
  const [selectedVersion, setSelectedVersion] = useState(null);

  const tooltipTitle = (
    <div>
      <div>{workflow?.id}</div>
      <div>{workflow?.person}</div>
    </div>
  );

  const title = (
    <Tooltip title={tooltipTitle} theme="light">
      <div>{_.startCase(workflow?.identifier)}</div>
    </Tooltip>
  );

  const subtitle = (
    <div>
      <div className="vega info">{workflow?.location}</div>
      <Timestamp timestamp={workflow?.updatedAt || workflow?.createdAt} small />
    </div>
  );

  return (
    <Tile
      header={{
        title,
        subtitle,
        collapsibleOnDesktop: true,
        collapsibleOnMobile: true,
        defaultCollapsed: true,
        accent: readOnly,
      }}
      noMarginBottom
      expand={expand}
    >
      <Tile.Inner noPadding>
        {showVersionHistory && workflow && (
          <div className="vega version-history-section">
            <FormulaVersionHistory
              formula={workflow}
              onVersionSelect={(version) => setSelectedVersion(version)}
              selectedVersionTimestamp={selectedVersion?.timestamp}
            />
          </div>
        )}
        {React.cloneElement(children, { selectedVersion })}
      </Tile.Inner>
    </Tile>
  );
};

export default Workflow;
